export const UPDATE_NOTE = `
  mutation UpdateNote($noteId: ID!, $description: String!, $userId: ID!, $entity: String!) {
    updateNote(noteId: $noteId, description: $description, userId: $userId, entity: $entity){
       notes {
        id
        description
        user {
          id
          name
        }
        updatedAt
        createdAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_NOTE = `
  mutation CreateNote($userId: ID!, $description: String!) {
    createNote(userId: $userId, description: $description){
       note {
        id
        description
        createdAt
        updatedAt
        user {
          id
        }
      }
      errors {
        property
        description
      }
    }
  }
`;